import { useEffect } from 'react';
import type { onMediaSrcExpiryErrorPropsT } from '../../../../../common/types/types';
import { MEDIA_EVENT_LISTENER } from '../constants/video-events';
import { getErrorFromMediaError } from '../utils/get-error-from-media-error';
type PropsT = {
  onError: (error: Error) => void;
  onSignedUrlExpiredError: (props: onMediaSrcExpiryErrorPropsT) => void;
  mediaElement: HTMLVideoElement | HTMLAudioElement | null;
};
export function useRefreshSignedUrlOnExpiry({
  mediaElement,
  onSignedUrlExpiredError,
  onError
}: PropsT) {
  useEffect(() => {
    if (!mediaElement) {
      return;
    }
    const handleError = () => {
      const mediaError = mediaElement.error;
      if (!mediaError) {
        return;
      }
      if (mediaError.code === MediaError.MEDIA_ERR_ABORTED) {
        return;
      }
      if (mediaError.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED || mediaError.code === MediaError.MEDIA_ERR_NETWORK) {
        onSignedUrlExpiredError({
          mediaError,
          skipSourceValidation: false
        });
        return;
      }
      onError(getErrorFromMediaError(mediaError));
    };
    mediaElement.addEventListener(MEDIA_EVENT_LISTENER.ERROR, handleError);
    return () => {
      mediaElement.removeEventListener(MEDIA_EVENT_LISTENER.ERROR, handleError);
    };
  }, [mediaElement, onSignedUrlExpiredError, onError]);
}